export const aplicacaoEstaContratada = (valor) =>
  valor === true || valor === 'true' || valor === 1 || valor === '1';
